import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';
import { webAuthnAuthenticatorQueryKeys, WebAuthnAuthenticators } from '#api';

type Args = Pick<
  UseMutationOptions<WebAuthnAuthenticators.DeleteAuthenticatorResult, unknown, string>,
  'onSuccess' | 'onError'
>;

export function useDeleteWebAuthnMutation({ onSuccess, onError }: Args = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => WebAuthnAuthenticators.deleteAuthenticator(id),
    onSuccess: (data, id, context) => {
      void queryClient.invalidateQueries({ queryKey: webAuthnAuthenticatorQueryKeys.lists() });
      onSuccess?.(data, id, context);
    },
    onError,
  });
}
